import styled, {css} from 'styled-components'
import { pxToRem } from 'styles/functions'

interface StyledSubtitleh2Props {
  theme: any;
}
export const StyledSubtitleh2 = styled.h2<StyledSubtitleh2Props>`
  margin: ${({ theme }) => (theme.subtitle_margin ? pxToRem(theme.subtitle_margin) : pxToRem(20))};
  text-transform: ${({ theme }) => theme.subtitle_text_transform};
  .type-listitem & {
    ${({ theme }) => theme.custom_listitem_subtitle_alatable && theme.custom_listitem_subtitle_alatable}
  }
`

interface StyledSubtitleh3Props {
  theme: any;
}
export const StyledSubtitleh3 = styled.h3<StyledSubtitleh3Props>`
  font-size: ${({ theme }) => (theme.subtitleH3_font_size ? pxToRem(theme.subtitleH3_font_size) : pxToRem(18))};
  margin: ${({ theme }) => (theme.subtitle_margin ? pxToRem(theme.subtitle_margin) : pxToRem(18))};
  text-transform: ${({ theme }) => theme.subtitle_text_transform};
  .type-listitem & {
    ${({ theme }) => theme.custom_listitem_subtitle_alatable && theme.custom_listitem_subtitle_alatable}
  }
  ${({ theme }) => theme.subtitleH3_font_weight && css`
    font-weight: ${theme.subtitleH3_font_weight};
  `}
`
